import { Reveal, SectionHead } from "./Reveal";
import { TESTIMONIALS } from "../lib/data";
import { Star } from "lucide-react";

export const Testimonials = () => (
  <section className="py-20 sm:py-28 lg:py-36 px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto" data-testid="testimonials-section">
    <SectionHead
      overline="Student love"
      title={<>They enrolled. <em className="text-gold-gradient not-italic">Then they earned.</em></>}
    />
    <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
      {TESTIMONIALS.map((t, i) => (
        <Reveal key={t.name} delay={i * 0.08}>
          <blockquote
            className="flex h-full flex-col rounded-2xl border border-white/10 bg-surface/70 p-8 hover:border-gold/40 transition-colors duration-500"
            data-testid={`testimonial-${i}`}
          >
            <div className="flex gap-1 text-gold">
              {Array.from({ length: 5 }).map((_, s) => (
                <Star key={s} size={13} fill="currentColor" />
              ))}
            </div>
            <p className="mt-5 flex-1 font-display text-lg leading-relaxed text-neutral-200 italic">“{t.quote}”</p>
            <footer className="mt-7 flex items-center gap-4 border-t border-white/10 pt-5">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gold/15 border border-gold/30 font-mono text-xs text-champagne">
                {t.initials}
              </span>
              <div>
                <p className="text-sm font-medium text-neutral-100">{t.name}</p>
                <p className="text-xs text-neutral-500">{t.role}</p>
              </div>
            </footer>
          </blockquote>
        </Reveal>
      ))}
    </div>
  </section>
);
